module.exports = __webpack_public_path__ + "media/images/emailicon-f31115123d0155982046d8aba2ab5a36.png";